// extracted by mini-css-extract-plugin
export default {"ButtonOrange":"ButtonOrangeLight_ButtonOrange__DdLHO"};